import {
  DatePicker,
  Form,
  Input,
  Modal,
  Radio,
  Select,
  Switch,
  Upload,
} from "antd";
import { useSelector } from "react-redux";
import styled from "styled-components";
import { MainColor } from "../variable/variable";
import { Checkbox } from "antd";
import React, { ReactNode } from "react";

interface IMyObject {
  _id?: any;
  name?: string;
  autoid?: any;
  value?: string;
}

export interface fromInput {
  type:
    | "input"
    | "option"
    | "radio"
    | "date"
    | "switch"
    | "textarea"
    | "checkbox"
    | "password"
    | "upload";
  label?: ReactNode;
  name?: string;
  rules?: Function;
  required?: Boolean | any;
  disable?: Boolean | any;
  placeholder?: string;
  data?: IMyObject[];
  typeParam?: any;
  onChange?: any;
  message?: string;
  style?: any;
  props?: any;
  mode?: "multiple" | "tags" | any;
  active?: boolean;
  isService?: boolean;
  labelColStyle?: any;
  password?: string;
  getId?: boolean;
  rows?: number;
  showSearch?: boolean;
  onSearch?: (value: string) => void;
  filterOption?: boolean;
  allowClear?: boolean;
}

export const FormInputStyle = styled.div`
  path {
    color: ${MainColor};
  }
  .ant-row.ant-form-item-row {
    display: block;
    .ant-form-item-label {
      font-size: 13px;
      font-weight: bold;
    }
  }

  .ant-col.ant-form-item-label {
    text-align: inherit;
    ::after {
      display: none !important;
    }
  }
`;
const BaseFormInput = ({
  label,
  name,
  type,
  required,
  disable,
  placeholder,
  data,
  typeParam,
  onChange,
  message,
  style,
  mode,
  active,
  getId,
  labelColStyle,
  password,
  rows,
  props,
}: fromInput) => {
  const dataParam = useSelector((state: any) => state?.usersSlice?.param) || [];
  const dataPramType = data && data ? data : dataParam[typeParam];
  const dateFormatList = "DD/MM/YYYY";
  const [previewOpen, setPreviewOpen] = React.useState(false);
  const [previewImage, setPreviewImage] = React.useState("");
  const [previewTitle, setPreviewTitle] = React.useState("");
  const handlePreview = async (file: any) => {
    if (!file.url && !file.preview) {
      file.preview = await new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(file.originFileObj);
        reader.onload = () => resolve(reader.result as string);
      });
    }

    setPreviewImage(file.url || file.preview);
    setPreviewOpen(true);
    setPreviewTitle(
      file.name || file.url!.substring(file.url!.lastIndexOf("/") + 1)
    );
  };

  return (
    <FormInputStyle>
      {type == "switch" ? (
        <Form.Item
          label={label}
          name={name}
          valuePropName="checked"
          getValueFromEvent={(e) => {
            if (Array.isArray(e)) return e;
            return e?.fileList || [];
          }}
          rules={[
            {
              required: required,
              validator: (_, value) => {
                if (!required) return Promise.resolve();
                if (!value || value.length === 0) {
                  return Promise.reject(
                    new Error(message || "Vui lòng chọn ảnh")
                  );
                }
                return Promise.resolve();
              },
            },
          ]}>
          <Upload
            {...props}
            listType={props?.listType || "picture-card"}
            beforeUpload={props?.beforeUpload || (() => false)}
            onPreview={handlePreview}>
            {props?.uploadButton || <div>+</div>}
          </Upload>
        </Form.Item>
      ) : type === "upload" ? (
        <Form.Item
          label={label}
          name={name}
          valuePropName="fileList"
          getValueFromEvent={(e) => {
            if (Array.isArray(e)) return e;
            return e?.fileList || [];
          }}
          rules={[
            {
              required: required,
              validator: (_, value) => {
                if (!required) return Promise.resolve();
                if (!value || value.length === 0) {
                  return Promise.reject(
                    new Error(message || "Vui lòng chọn ảnh")
                  );
                }
                return Promise.resolve();
              },
            },
          ]}>
          <Upload
            {...props}
            listType={props?.listType || "picture-card"}
            beforeUpload={props?.beforeUpload || (() => false)}
            onPreview={handlePreview}>
            <div>+</div>
          </Upload>
          <Modal
            open={previewOpen}
            title={previewTitle}
            footer={null}
            onCancel={() => setPreviewOpen(false)}>
            <img alt="preview" style={{ width: "100%" }} src={previewImage} />
          </Modal>
        </Form.Item>
      ) : (
        <Form.Item
          label={label}
          name={name}
          rules={[{ required: required, message }]}
          labelCol={labelColStyle}
          valuePropName={type === "checkbox" ? "checked" : "value"}
          initialValue={type === "checkbox" ? false : undefined}>
          {type == "input" ? (
            <Input
              {...props}
              disabled={disable}
              placeholder={placeholder}
              onChange={onChange}
              style={style}
              type="text"
            />
          ) : type == "password" ? (
            <Input.Password
              {...props}
              disabled={disable}
              placeholder={placeholder}
              onChange={onChange}
              style={style}
            />
          ) : type == "textarea" ? (
            <Input.TextArea
              {...props}
              disabled={disable}
              placeholder={placeholder}
              onChange={onChange}
              style={style}
              rows={rows || 4}
            />
          ) : type == "checkbox" ? (
            <Form.Item
              name={name}
              valuePropName="checked"
              initialValue={false}
              rules={[{ required: required, message }]}
              labelCol={labelColStyle}
              style={{ transform: "scale(1.5)", transformOrigin: "0 0" }}>
              <Checkbox
                onChange={(e) => onChange?.(e.target.checked)}
                disabled={disable}></Checkbox>
            </Form.Item>
          ) : type == "option" ? (
            <Select
              {...props}
              allowClear={props?.allowClear}
              showSearch={props?.showSearch}
              optionFilterProp="children"
              placeholder={placeholder}
              style={style}
              mode={mode}
              disabled={disable}
              onSearch={props?.onSearch}
              filterOption={props?.filterOption ?? false}>
              {dataPramType?.map((val: any) => (
                <Select.Option key={val?.value} value={val?.value}>
                  {val?.label ?? val?.name}
                </Select.Option>
              ))}
            </Select>
          ) : type == "date" ? (
            <DatePicker
              style={{ width: "100%" }}
              placeholder="Chọn ngày"
              format={dateFormatList}
            />
          ) : (
            <Radio.Group>
              {data?.map((val) => (
                <Radio key={val?._id} value={val._id}>
                  {val.name}
                </Radio>
              ))}
            </Radio.Group>
          )}
        </Form.Item>
      )}
      <Modal
        open={previewOpen}
        title={previewTitle}
        footer={null}
        onCancel={() => setPreviewOpen(false)}>
        <img alt="preview" style={{ width: "100%" }} src={previewImage} />
      </Modal>
    </FormInputStyle>
  );
};

export default BaseFormInput;
